export default (num) => {
	const numberFormat = Intl.NumberFormat('ru-RU', {
		style: 'decimal'
	})
	return numberFormat.format(num)
}
